import { Box, Center, Container, Image, Text, VStack } from '@chakra-ui/react';
import { useCompanyStore } from '../../stores/companyStore';
import { GuestLayoutConfig } from '../../config/layoutConfig';
import { useTranslation } from 'react-i18next';

interface CommonLayoutProps {
  children: React.ReactNode;
  showLogo?: boolean;
}

const CommonLayout: React.FC<CommonLayoutProps> = ({
  children,
  showLogo = true,
}) => {
  const companyName = useCompanyStore((state) => state.company?.name);
  const companyLogo = useCompanyStore((state) => state.company?.logo);
  const year = new Date().getFullYear();
  const { t } = useTranslation();
  return (
    <Center minH="100vh">
      <VStack
        maxW={GuestLayoutConfig.maxWidth}
        w="100%"
        justify="center"
        align="center"
        gap="0"
      >
        <Box as="header" textAlign="center">
          {showLogo && companyLogo && (
            <Image src={`${companyLogo}`} maxH="50px" />
          )}
        </Box>
        {/* <Box h="40px"></Box> */}
        <Container as="main" p="25px" w="100%">
          {children}
        </Container>
        <Box h="20px"></Box>

        <Box as="footer" textAlign="center">
          {companyName && (
            <Text>
              {year} © {companyName}. {t('common:footerRights')}
            </Text>
          )}
        </Box>
      </VStack>
    </Center>
  );
};

export default CommonLayout;
